/**
 * Teaser Data — 티저 페이지 고정 매핑표
 *
 * 여기에는 "판정"이 없다. 표만 있다.
 * 用神·身強弱·十神·大運·神煞은 만세력 엔진이 계산한 값을 서버가 그대로 내려준다.
 * 이 파일은 그 값을 화면 문구로 바꾸는 사전일 뿐이다.
 *
 * ⚠️ 관상 문구는 반드시 2단 키(부위 → 폼 값)로 찾는다.
 *    폼 선택지 `適中`이 鼻梁·唇形 두 곳에 있어서, 단일 사전으로 만들면 문구가 섞인다.
 *
 * 문구 원본: claude/in-progress/2026-08-11_love-티저페이지-구현/부록_문구표.md
 */
window.TEASER_DATA = (function () {
  'use strict';

  // ─── 천간 · 지지 ────────────────────────────────────────────────────────

  var STEMS    = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'];
  var BRANCHES = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];

  var STEM_ELEMENT = {
    甲: '木', 乙: '木', 丙: '火', 丁: '火', 戊: '土',
    己: '土', 庚: '金', 辛: '金', 壬: '水', 癸: '水'
  };

  var BRANCH_ELEMENT = {
    子: '水', 丑: '土', 寅: '木', 卯: '木', 辰: '土', 巳: '火',
    午: '火', 未: '土', 申: '金', 酉: '金', 戌: '土', 亥: '水'
  };

  // ─── 한글 독음 (표시 전용) ──────────────────────────────────────────────
  //
  // 四柱原局 표에서 **큰 글자로 나가는 값**이다. 한자는 그 아래 작게 붙는다.
  // 이 서비스가 한국 사주명리 기반임을 화면에서 바로 알아보게 하려는 것이다.
  // (처음엔 반대였다 — 한자가 크고 한글이 작은 보조 표기였다. 위계를 뒤집은 경위는
  //  claude/in-progress/2026-08-13_티저-사주표-한글주역전환/ 참조)
  //
  // 🔴 그릴 때만 통과시킨다. 원본 값(hanja·stemSipseong)은 절대 바꾸지 않는다.
  //    아래 CALENDAR_LABEL 주석과 같은 원칙이다 — 원본을 바꾸면 서버 판정이 깨지고
  //    에러도 안 나면서 결과가 통째로 틀린다.
  //
  // 🔴 여기에 값을 추가하면 layout/theme.liquid 의 Noto Serif KR 서브셋 text= 도
  //    같이 늘려야 한다. 안 늘리면 그 글자만 두부(□)로 나온다.
  //
  // ⚠️ 천간 辛과 지지 申이 둘 다 「신」이다. 큰 글자가 한글이 된 지금은
  //    天干 행의 「신」과 地支 행의 「신」이 같은 크기로 보인다. 행이 다르고
  //    아래에 한자가 붙어 있어 구분은 되지만, 한자를 없애면 이 충돌이 살아난다.

  var STEM_KR = {
    甲: '갑', 乙: '을', 丙: '병', 丁: '정', 戊: '무',
    己: '기', 庚: '경', 辛: '신', 壬: '임', 癸: '계'
  };

  var BRANCH_KR = {
    子: '자', 丑: '축', 寅: '인', 卯: '묘', 辰: '진', 巳: '사',
    午: '오', 未: '미', 申: '신', 酉: '유', 戌: '술', 亥: '해'
  };

  // 十神 10종 + 日主.
  // 日主는 일주 칸에 십신 대신 들어가는 값이라(teaser.js renderTable) 빠뜨리면 그 칸만 한글이 없다.
  // 키는 서버가 sipseongToHanja 로 변환해 보내는 번체 그대로다
  // (hk-saju-server/functions/src/utils/mapping.ts).
  var SIPSEONG_KR = {
    比肩: '비견', 劫財: '겁재',
    食神: '식신', 傷官: '상관',
    偏財: '편재', 正財: '정재',
    偏官: '편관', 正官: '정관',
    偏印: '편인', 正印: '정인',
    日主: '일주'
  };

  // 陽干 / 陰干 — 십신 판정에 쓴다
  var STEM_YANG = { 甲: true, 乙: false, 丙: true, 丁: false, 戊: true, 己: false, 庚: true, 辛: false, 壬: true, 癸: false };

  // 오행 상생·상극
  var GENERATES = { 木: '火', 火: '土', 土: '金', 金: '水', 水: '木' }; // A 生 B
  var CONTROLS  = { 木: '土', 土: '水', 水: '火', 火: '金', 金: '木' }; // A 剋 B

  // ─── 계절 (월지 기준) ───────────────────────────────────────────────────
  // 土는 당령이 없다. 당령오행은 木火金水 넷뿐이다.

  var BRANCH_SEASON = {
    寅: '春', 卯: '春', 辰: '春',
    巳: '夏', 午: '夏', 未: '夏',
    申: '秋', 酉: '秋', 戌: '秋',
    亥: '冬', 子: '冬', 丑: '冬'
  };

  var SEASON_ELEMENT = { 春: '木', 夏: '火', 秋: '金', 冬: '水' };

  // ─── 지지 관계 ──────────────────────────────────────────────────────────
  // 유월지 ↔ 일지 판정용. 엔진의 branchRelations는 원국 안쪽만 계산하므로 쓸 수 없다.

  function pairKey(a, b) { return a < b ? a + b : b + a; }

  function toSet(pairs) {
    var set = {};
    pairs.forEach(function (p) { set[pairKey(p[0], p[1])] = true; });
    return set;
  }

  var SIX_HARMONY = toSet([['子','丑'], ['寅','亥'], ['卯','戌'], ['辰','酉'], ['巳','申'], ['午','未']]);
  var CLASH       = toSet([['子','午'], ['丑','未'], ['寅','申'], ['卯','酉'], ['辰','戌'], ['巳','亥']]);
  var HARM        = toSet([['子','未'], ['丑','午'], ['寅','巳'], ['卯','辰'], ['申','亥'], ['酉','戌']]);
  var BREAK       = toSet([['子','酉'], ['丑','辰'], ['寅','亥'], ['卯','午'], ['巳','申'], ['未','戌']]);
  var WONJIN      = toSet([['子','未'], ['丑','午'], ['寅','酉'], ['卯','申'], ['辰','亥'], ['巳','戌']]);

  // 刑 — 삼형은 두 글자만으로도 걸리는 조합만 넣는다. 자형(辰辰·午午·酉酉·亥亥)은 별도 처리.
  var PUNISH      = toSet([['寅','巳'], ['巳','申'], ['寅','申'], ['丑','戌'], ['戌','未'], ['丑','未'], ['子','卯']]);
  var SELF_PUNISH = { 辰: true, 午: true, 酉: true, 亥: true };

  // 暗合 — 겉의 지지끼리는 합이 아닌데 지장간끼리 합하는 관계.
  //   子戌(癸戊) · 丑寅(甲己) · 寅未(甲己) · 卯申(乙庚) · 午亥(丁壬)
  // 드러나지 않는 인연이라 曖昧에 대응한다.
  // 巳酉(丙辛)는 巳酉丑 반합으로 먼저 걸리므로 넣지 않는다.
  var HIDDEN_HARMONY = toSet([['子','戌'], ['丑','寅'], ['寅','未'], ['卯','申'], ['午','亥']]);

  // 三合局 — 生地 / 旺地 / 庫地
  var THREE_HARMONY = [
    { branches: ['申', '子', '辰'], king: '子', element: '水' },
    { branches: ['寅', '午', '戌'], king: '午', element: '火' },
    { branches: ['巳', '酉', '丑'], king: '酉', element: '金' },
    { branches: ['亥', '卯', '未'], king: '卯', element: '木' }
  ];

  // 桃花(年殺) — 일지가 속한 삼합국의 왕지 다음 글자
  //   寅午戌 → 卯 / 申子辰 → 酉 / 巳酉丑 → 午 / 亥卯未 → 子
  var PEACH_OF_GROUP = { 午: '卯', 子: '酉', 酉: '午', 卯: '子' };

  // ─── 五虎遁 — 연간 → 寅월 천간 ──────────────────────────────────────────
  //   甲己→丙寅 · 乙庚→戊寅 · 丙辛→庚寅 · 丁壬→壬寅 · 戊癸→甲寅

  function tigerStemIndex(yearStemIndex) {
    return ((yearStemIndex % 5) * 2 + 2) % 10;
  }

  // ─── 관상 궁위 ──────────────────────────────────────────────────────────
  // 눈꼬리는 夫妻宮을 쓴다. 妻妾宮은 남성 관점 표현이라 연애 상품에 맞지 않는다.
  // 입술(五官 出納官)과 입꼬리(五星 水星)를 나눈 것은 같은 이름이 두 번 나오지 않게 하기 위함이다.

  var FACE_PARTS = [
    // 궁위는 결과지(public/js/result.js FACE_PARTS)와 같은 정식 명칭을 쓴다.
    // 축약형(田宅·蘭台·出納)을 쓰면 결제 전후로 다른 이름이 되어 고객이 헷갈린다.
    { key: '眼形', palace: '田宅宮' },
    { key: '眼尾', palace: '夫妻宮' },
    { key: '眉形', palace: '兄弟宮' },
    { key: '鼻梁', palace: '疾厄宮', label: '鼻樑' },  // 표시는 번체 표준 鼻樑, 폼 이름은 鼻梁 그대로
    { key: '鼻孔', palace: '蘭台廷尉' },
    { key: '唇形', palace: '出納官' },
    { key: '嘴角', palace: '水星' }
  ];

  // ─── 관상 문구 24 (2단 키) ──────────────────────────────────────────────
  // 바깥 키 = 폼의 properties[...] 이름, 안쪽 키 = 폼 선택지 값 (한 글자도 바꾸지 않는다)
  // text = 표시 라벨, line = 카드 문구 (말줄임표 유지 — 완결본은 결과지에 있다)

  var FACE_COPY = {
    眼形: {
      單眼皮:     { text: '單眼皮',     line: '你不會先開口，但你記得最久…' },
      隱形雙眼皮: { text: '隱形雙眼皮', line: '你看人平靜，心裡已經決定了…' },
      內雙眼皮:   { text: '內雙眼皮',   line: '你不容易動心，動了也不講…' },
      外雙眼皮:   { text: '外雙眼皮',   line: '看你一眼就記住你…' },
      開扇形:     { text: '開扇形',     line: '你看得見全場，也讓全場看見你…' },
      新月形:     { text: '新月形',     line: '你笑起來像沒有防備，其實你在看…' }
    },
    眼尾: {
      眼尾上揚: { text: '上揚', line: '主導感情，卻不先開口…' },
      平直眼尾: { text: '平直', line: '你講公平，但感情不講公平…' },
      眼尾下垂: { text: '下垂', line: '你先心軟，所以你先累…' }
    },
    眉形: {
      彎月眉: { text: '彎月眉', line: '不出聲，也留得住目光…' },
      淡散眉: { text: '淡眉',   line: '你不爭，所以人以為你不想要…' },
      一字眉: { text: '一字眉', line: '你要的界線很直，越過了就沒有第二次…' },
      劍眉:   { text: '劍眉',   line: '你講得出就做得到，也講得太直…' }
    },
    鼻梁: {
      高挺: { text: '高而直', line: '清楚自己值多少，所以不肯…' },
      適中: { text: '中等',   line: '你懂得讓，卻不懂何時停…' },
      平順: { text: '低平',   line: '你先想別人，最後才想自己…' }
    },
    鼻孔: {
      略露: { text: '微露',   line: '你有底線，但底線會移…' },
      內藏: { text: '不外露', line: '守得住緣，也守得太緊…' }
    },
    唇形: {
      豐厚: { text: '厚',     line: '你講得暖，所以人捨不得走…' },
      // 「不夠」는 부족을 말하는 표현이라 결과지 톤(과유불급)과 어긋난다.
      // 같은 뜻을 「절제가 지나치다」로 뒤집어 톤을 맞춘다.
      適中: { text: '中等',   line: '你的話收得太準，所以留白太多…' },
      纖薄: { text: '薄',     line: '話說得準，情就藏得深…' }
    },
    嘴角: {
      仰月: { text: '向上', line: '一笑就留得住人，代價是你自己也…' },
      端正: { text: '平',   line: '你不給表情，所以旁人總猜錯你…' },
      覆舟: { text: '向下', line: '你不裝，所以真心的人才留下…' }
    }
  };

  // ─── 七處 충돌 10쌍 ─────────────────────────────────────────────────────
  // 서로 반대 방향으로 당기는 조합만 인정한다. 위에서부터 첫 매칭 하나만 쓴다.
  // 부위명은 둘 다 잠근다 — 하나만 가리면 나머지로 추측이 된다.

  var FACE_CONFLICTS = [
    { code: 'PULL_PUSH',   a: ['鼻梁', '高挺'],     b: ['嘴角', '仰月'] },
    { code: 'LEAD_SILENT', a: ['眼尾', '眼尾上揚'], b: ['唇形', '纖薄'] },
    { code: 'OPEN_GUARD',  a: ['眼形', '外雙眼皮'], b: ['鼻孔', '內藏'] },
    { code: 'WARM_COLD',   a: ['唇形', '豐厚'],     b: ['嘴角', '端正'] },
    { code: 'WAIT_SEEN',   a: ['眼形', '單眼皮'],   b: ['嘴角', '仰月'] },
    { code: 'YIELD_HOLD',  a: ['鼻梁', '平順'],     b: ['鼻孔', '內藏'] },
    { code: 'SOFT_SHARP',  a: ['眼尾', '眼尾下垂'], b: ['眉形', '劍眉'] },
    { code: 'PLAIN_PULL',  a: ['嘴角', '覆舟'],     b: ['眼形', '外雙眼皮'] },
    { code: 'GIVE_KEEP',   a: ['唇形', '豐厚'],     b: ['鼻梁', '高挺'] },
    { code: 'EXPOSE_HIDE', a: ['鼻孔', '略露'],     b: ['唇形', '纖薄'] }
  ];

  // ─── 일간 × 계절 성격 40 ────────────────────────────────────────────────

  var STEM_SEASON_LINE = {
    甲: { 春: '你認定了就一直走，不懂轉彎。',      夏: '你對人好得快，累得也快。',
          秋: '你不肯彎，所以容易折。',            冬: '你等得起，但等到最後會怨。' },
    乙: { 春: '你會順著人走，但心裡有數。',        夏: '你捨得低頭，捨不得放手。',
          秋: '你軟得住，但不會忘。',              冬: '你熬得過冷，熬不過孤單。' },
    丙: { 春: '你一開口就熱，收不回來。',          夏: '你亮得太快，人未跟上你已經冷。',
          秋: '你熱得起，但沒人看得見。',          冬: '你把光留給別人，自己凍著。' },
    丁: { 春: '你不會大聲，但你記得所有細節。',    夏: '你燒得慢，一燒就不停。',
          秋: '你照亮人心，自己黑著。',            冬: '你的燈細，但不熄。' },
    戊: { 春: '你頂得住，所以人習慣把你放最後。',  夏: '你講忠誠，卻不講需要。',
          秋: '你收得太埋，連自己都找不到。',      冬: '你守得住，守到人走了也不問。' },
    己: { 春: '你容得下人，容到自己沒位置。',      夏: '你細心到人以為你不介意。',
          秋: '你收得住話，收不住心。',            冬: '你養得起人，養不起自己。' },
    庚: { 春: '你分得清，所以斷得快。',            夏: '你硬得起，軟下來就沒聲。',
          秋: '不講就是不講，一講就是一刀。',      冬: '你冷得住，但你其實想有人問。' },
    辛: { 春: '你不肯將就，所以等得久。',          夏: '你外面利，裡面易傷。',
          秋: '你嘴比心快，心比嘴軟。',            冬: '你精緻，但冷。' },
    壬: { 春: '你哪裡都去得，所以沒有落腳的地方。', 夏: '你識人多，交心少。',
          秋: '你看得清，卻不肯講。',              冬: '你深，深到人怕。' },
    癸: { 春: '你細細滲進人心，不聲不響。',        夏: '你力量不足，但你不會斷。',
          秋: '你敏感到辛苦，人未講你已經知。',    冬: '你靜，靜到人以為你不痛。' }
  };

  // ─── 월운 문장 뱅크 48 ──────────────────────────────────────────────────
  // 接得上으로 세는 것은 桃花 · 機遇 · 圓滿 셋뿐이다.

  var MONTHLY_KEYWORDS = ['桃花', '機遇', '圓滿', '甜蜜', '深化', '穩定', '曖昧', '波動', '注意', '獨處', '重逢', '告白'];
  var CONNECTED_KEYWORDS = ['桃花', '機遇', '圓滿'];

  // 카드의 하트(강도) — 5점 만점
  var KEYWORD_STARS = {
    桃花: 5, 機遇: 4, 圓滿: 4, 告白: 4,
    甜蜜: 3, 重逢: 3,
    深化: 2, 穩定: 2, 曖昧: 2,
    波動: 1, 注意: 1, 獨處: 1
  };

  var MONTHLY_LINES = {
    桃花: [
      '一直對你有意思的人，會先開口。',
      '你不用主動，人自己會靠過來。',
      '有人遠遠看了你很久，終於走近。',
      '你比平時亮，看見你的人會記住。'
    ],
    機遇: [
      '新的場合會帶來新的名字，別推掉邀約。',
      '相遇來得突然，但不是偶然。',
      '有一個安排會被改動，改動之後才遇得上。',
      '工作或朋友的圈子裡，會多出一個人。'
    ],
    圓滿: [
      '拖了很久的事，會有一個定案。',
      '兩個人的節奏，終於對得上。',
      '該說的話說出口，關係會往前一格。',
      '適合把關係講清楚，講了不會壞。'
    ],
    甜蜜: [
      '相處會變得輕鬆，不用再猜對方在想什麼。',
      '小事會讓你們更近，不是大事。',
      '溫度剛好，不燙也不冷。',
      '有人會用你聽得懂的方式對你好。'
    ],
    深化: [
      '表面沒有變化，底下已經不一樣了。',
      '不會發生什麼，但你會更確定。',
      '相處久了才看得見的一面，會露出來。',
      '沒有新的人出現，原本的關係卻更沉了。'
    ],
    穩定: [
      '不動最好，動了反而要重來。',
      '該有的都在，只是不熱鬧。',
      '維持原樣就是進展，不用著急。',
      '這個月適合守，不適合攻。'
    ],
    曖昧: [
      '有意思，但誰都不肯先講。',
      '距離不遠不近，短期內大概也不會變。',
      '訊息來得勤，話卻停在半路。',
      '你分不清是客氣還是喜歡，之後也分不清。'
    ],
    波動: [
      '情緒會起伏，先別做決定。',
      '一件小事會被放大，過幾天就沒事。',
      '話容易說重，但吵完不一定散。',
      '計劃會被打斷一次，不是壞事。'
    ],
    注意: [
      '話說重了收不回來，少講一句比較好。',
      '有人會誤會你的好意，解釋一次就好。',
      '別替人做決定，做了反而會被怪。',
      '別急著承諾，說了就要做到。'
    ],
    獨處: [
      '適合一個人待著，勉強湊近反而累。',
      '想見的人見不到，見到的人不想見。',
      '安靜一段時間，你會看清楚要的是誰。',
      '這個月的空，是給下個月留位置。'
    ],
    重逢: [
      '過去的名字會再出現一次，看你接不接。',
      '以為早就過去的人，會傳來消息。',
      '同一個地方，會遇到同一個人。',
      '有些事沒有結束，只是停在那裡等你。'
    ],
    告白: [
      '有人準備了很久，終於會說出口。',
      '該表態的是你，不是對方。',
      '一句話會改變兩個人的位置。',
      '願意先開口的人，不會後悔。'
    ]
  };

  // ─── 曆法 표시 변환 ─────────────────────────────────────────────────────
  //
  // 홍콩에서는 음력을 「農曆」이라 부른다. 화면에는 그렇게 보여준다.
  //
  // 🔴 폼 값(`陰曆`)은 절대 바꾸지 않는다.
  //    서버가 calendarType === "陰曆" 인지를 **글자 그대로 비교**해서
  //    음력/양력을 가른다. 폼 값이 「農曆」이 되면 양력으로 계산돼
  //    음력 고객의 사주 8글자가 통째로 틀린다. 에러도 안 나고 화면도 정상으로 보인다.
  //
  //    그래서 이 표는 **그릴 때만** 거친다. 원본 값은 손대지 않는다.
  var CALENDAR_LABEL = { 陰曆: '農曆' };

  // ─── 화면 고정 문구 ─────────────────────────────────────────────────────

  var TEXT = {
    // 오행균형 — 조건·잠금값 모두 用神 기준
    balanceLow:    ['你這個盤，本身不差。', '但你缺的，正是你最需要的。', '而這個缺口，正好落在你的姻緣上。'],
    balanceEnough: ['你這個盤，本身不差。', '但你有的，還沒用在對的地方。', '而這一點，正好落在你的姻緣上。'],

    // 七處 충돌
    conflictNone: '七處所指，方向一致。',

    // 월운 카운트
    connectedZero: '未來十二個月，姻緣未見動。',

    // 출생시간 未知
    hourUnknownNote:   '時辰未提供，時柱不作判斷。',
    dohwaPendingTitle: '桃花・待定',
    dohwaPendingBody:  '你的桃花可能落在時柱。補上時辰即可判定。',
    dohwaNeedHour:     '需時辰',
    reorderNote:       '補上時辰後可重新推算，需另行下單。',

    // 상태
    loadFailed: '命盤讀取失敗，請返回重新輸入。',

    // 사주표에서 값이 없을 때
    dash: '—'
  };

  // ─── 공개 ───────────────────────────────────────────────────────────────

  return {
    STEMS: STEMS,
    BRANCHES: BRANCHES,
    STEM_ELEMENT: STEM_ELEMENT,
    BRANCH_ELEMENT: BRANCH_ELEMENT,
    STEM_KR: STEM_KR,
    BRANCH_KR: BRANCH_KR,
    SIPSEONG_KR: SIPSEONG_KR,
    STEM_YANG: STEM_YANG,
    GENERATES: GENERATES,
    CONTROLS: CONTROLS,
    BRANCH_SEASON: BRANCH_SEASON,
    SEASON_ELEMENT: SEASON_ELEMENT,

    pairKey: pairKey,
    SIX_HARMONY: SIX_HARMONY,
    CLASH: CLASH,
    HARM: HARM,
    BREAK: BREAK,
    WONJIN: WONJIN,
    PUNISH: PUNISH,
    SELF_PUNISH: SELF_PUNISH,
    HIDDEN_HARMONY: HIDDEN_HARMONY,
    THREE_HARMONY: THREE_HARMONY,
    PEACH_OF_GROUP: PEACH_OF_GROUP,
    tigerStemIndex: tigerStemIndex,

    FACE_PARTS: FACE_PARTS,
    FACE_COPY: FACE_COPY,
    FACE_CONFLICTS: FACE_CONFLICTS,
    STEM_SEASON_LINE: STEM_SEASON_LINE,
    CALENDAR_LABEL: CALENDAR_LABEL,

    MONTHLY_KEYWORDS: MONTHLY_KEYWORDS,
    CONNECTED_KEYWORDS: CONNECTED_KEYWORDS,
    KEYWORD_STARS: KEYWORD_STARS,
    MONTHLY_LINES: MONTHLY_LINES,

    TEXT: TEXT
  };
})();
